import React, { useEffect, useState } from "react";
import {
	Grid,
	InputLabel,
	FormControl,
	TextField,
	Button,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	useMediaQuery,
	FormHelperText,
	Typography,
	Checkbox,
} from "@mui/material";
import styled, {
	inputImages,
	inputNumbers,
	inputStyles,
} from "../../Utils/inputChanges";
import Titlebar from "../TitleBar";
import { StudenMenu, Zones } from "../TitleList";
import { selectZones } from "../Selectors/Master/ZoneSelectors";

import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import DateInputComponent from "../FieldsComponents/DateInputComponent";
import { getCurrentDate } from "../../Utils/Dateutils";
import { insertStudenEntry } from "../../Store/PHPSlice/zone";
import { fetchLocationData } from "../../Store/PHPSlice/LocationApi";
import { selectLocations } from "../Selectors/Master/OutwardSelectors";
import Dropdown from "../FieldsComponents/Dropdown";
import axios from "axios";

const StudentEntry = () => {
	const userdata = JSON.parse(sessionStorage.getItem("user"));
	const baseUrl = process.env.REACT_APP_BASE_URL;
	const [formData, setFormData] = useState({
		studNm: "",
		dt: getCurrentDate(),
		div: "-",
		std: "-",
		age: "",
		ph: "",
		schlId: "",
		zoneId: "",
		userId: userdata?.ID,
	});
	const [schlList, setSchlList] = useState([]);
	const [zoneList, setZoneList] = useState([]);

	const dispatch = useDispatch();
	const schldata = useSelector(selectLocations);

	useEffect(() => {
		dispatch(fetchLocationData());
	}, [dispatch]);

	useEffect(() => {
		if (!userdata) return;

		if (userdata?.pageIds?.length > 0 && userdata?.role !== "1") {
			const selectpid = userdata?.pageIds?.filter(
				(item) => item === 1 || item === 2
			);
			if (selectpid?.length > 0) {
				const data = {
					uid: userdata?.ID,
					pageId: selectpid,
				};
				fetchPageAssignSchools(data);
			}
		}
	}, []);

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value.toUpperCase(),
		});
	};
	const handleDateChange = (e) => {
		setFormData({
			...formData,
			dt: e.target.value,
		});
	};
	const fetchZonesBySchool = async (schoolId) => {
		console.log(schoolId);
		try {
			let response = await axios.get(
				`${baseUrl}?apicall=getfetchZonesBySchool&schlId=${schoolId}`
			);
			// response = JSON.parse(response?.data?.data);
			//console.log(typeof response?.data?.data);
			setZoneList(response?.data?.data ?? []);
			console.log(zoneList); // assume API returns array of zones
		} catch (error) {
			console.error("Error fetching zones:", error);
			setZoneList([]); // fallback empty
		}
	};
	const fetchPageAssignSchools = async (id) => {
		const { uid, pageId } = id;
		try {
			const response = await axios.get(
				`${baseUrl}?apicall=getUserwisePageIdSchools&uid=${uid}&pageId=${pageId}`
			);
			setSchlList(response?.data?.data);
			// console.log(response.data)
		} catch (error) {
			console.error("Error fetching info list:", error);
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		// console.log("Final formData =>", formData);

		if (formData.studNm === "") {
			alert("Please Enter Student Name");
			return;
		}
		if (formData.schlId === "") {
			alert("Please Select School Code.");
			return;
		}
		// if (formData.div === '') {
		//     alert('Please Enter Division');
		//     return;
		// }
		/*const data = new FormData();
        data.append("studNm",formData.studNm);
        data.append("dt",formData.dt);
        data.append("div",formData.div);
        data.append("userId",formData.userId);
        data.append("std",formData.std);
        data.append("ph",formData.ph);
        data.append("age",formData.age);
        data.append("schlId",formData.schlId);
        data.append("zoneId",formData.zoneId);*/
		dispatch(insertStudenEntry({ postData: formData }))
			.unwrap()
			.then((result) => {
				// console.log('POST request successful!', result);
				alert("Student Added");
				window.location.reload();
			})
			.catch((error) => {
				console.error("Error while making POST request:", error);
			});
	};

	const isDesktop = useMediaQuery("(min-width:768px)");

	const fieldsecond = [
		{ label: "Date", name: "dt", type: "date" },
		{ label: "Student Name", name: "studNm" },
		{ label: "Age", name: "age" },
		{ label: "Standard", name: "std" },
		{ label: "Division", name: "div" },
		{ label: "Contact", name: "ph" },
	];

	const dropdownOrdType = [
		{
			label: "School",
			id: "schlId",
			options: userdata?.role !== "1" ? schlList : schldata?.data || [],
			value: formData.schlId,
			onChange: (newValue) => {
				const schoolId = newValue ? newValue.ID : "";
				//console.log(schoolId);
				handleDropdownChange(
					{ target: { name: "schlId", value: schoolId } },
					"schlId"
				);
				if (schoolId) {
					fetchZonesBySchool(schoolId); //
				} else {
					console.log(zoneList);
					setZoneList([]); // reset zones if no school
				}
			},
			getOptionLabel: (option) => option.schlcd || "",
			isOptionEqualToValue: (option, value) => option.ID === value.ID,
			valueFinder: (options, value) => {
				if (Array.isArray(options)) {
					return options.find((item) => item.ID === value) || null;
				}
				return null;
			},
			bold: true,
		},
		{
			label: "Zone",
			id: "zoneId",
			options: zoneList,
			value: formData.zoneId || "",
			onChange: (newValue) =>
				handleDropdownChange(
					{
						target: {
							name: "zoneId",
							value: newValue ? newValue.zoneId : "",
						},
					},
					"zoneId"
				),
			getOptionLabel: (option) => option.zoneNm || "", // depends on API response
			isOptionEqualToValue: (option, value) =>
				option.zoneId === value.zoneId,
			valueFinder: (options, value) => {
				if (Array.isArray(options)) {
					return (
						options.find((item) => item.zoneId === value) || null
					);
				}
				return null;
			},
			bold: true,
		},
	];

	/* const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
            
        });
        
        
    };*/
	const handleDropdownChange = (e, dropdownType) => {
		const { value } = e.target;

		switch (dropdownType) {
			case "schlId":
				setFormData((prev) => ({
					...prev,
					schlId: value,
					zoneId: "", // reset zone when school changes
				}));
				if (value) {
					fetchZonesBySchool(value);
				} else {
					setZoneList([]);
				}
				break;

			case "zoneId":
				setFormData((prev) => ({
					...prev,
					zoneId: value,
				}));
				break;

			default:
				break;
		}
	};

	return (
		<>
			<Titlebar data={StudenMenu} />
			<div style={{ margin: "1% 0.5%" }}>
				<h2>Student Entry</h2>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Paper style={{ padding: "2vh" }}>
							<Grid container spacing={1.2}>
								{fieldsecond?.map((field) => (
									<DateInputComponent
										key={field.name}
										formData={formData}
										handleDateChange={handleDateChange}
										handleInputChange={handleInputChange}
										styled={styled}
										inputStyles={inputStyles}
										isDesktop={isDesktop}
										field={field}
									/>
								))}

								{dropdownOrdType?.map((drop) => (
									<Dropdown
										key={drop.label}
										label={drop.label}
										id={drop.id}
										options={drop.options}
										value={drop.value}
										onChange={drop.onChange}
										isDesktop={isDesktop}
										getOptionLabel={drop.getOptionLabel}
										isOptionEqualToValue={
											drop.isOptionEqualToValue
										}
										valueFinder={drop.valueFinder} // Pass `valueFinder` function here
									/>
								))}

								<Grid item xs={12} textAlign="center">
									<Button
										variant="contained"
										color="primary"
										onClick={handleSubmit}
									>
										Submit
									</Button>
								</Grid>
							</Grid>
							<ToastContainer />
						</Paper>
					</Grid>
				</Grid>
			</div>
		</>
	);
};

export default StudentEntry;
